import { Grid, TextField } from '@material-ui/core'
import moment from 'moment-timezone'
import { useState, Fragment } from 'react'

import { DateRange } from 'react-date-range'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { openDialog } from '../../../actions/dialogs'
import { OpenDialog } from '../../../actions/types'
import Dialog from '../../../containers/Dialog'
import 'react-date-range/dist/styles.css' // main css file
import './dateRangePickerTheme.css' // theme css file

interface ReduxDateRangePickerProps {
  input: any
  meta: any
  label: string
  custom: any
}

interface DispatchProps {
  openDialog: OpenDialog
}

type ComponentProps = ReduxDateRangePickerProps &
  WithTranslation &
  DispatchProps

const ReduxDateRangePicker: React.FunctionComponent<ComponentProps> = ({
  input: { onChange, value },
  meta: { touched, invalid, error, active },
  t,
  openDialog
}) => {
  /** makes sure that range is not zeroed */
  const getRange = () => {
    const startDate = value.startDate ? value.startDate : new Date()
    const endDate = value.endDate ? value.endDate : startDate
    return {
      startDate,
      endDate,
      key: 'selection'
    }
  }

  const [range, setRange] = useState(getRange)

  const handleClickOpenCalendar = () => {
    openDialog(`CalendarDialog`)
  }

  const handleSelection = (range: any) => {
    setRange({
      startDate: range.selection.startDate,
      endDate: range.selection.endDate,
      key: range.selection.key
    })
  }

  const handleOnChange = () => {
    onChange({
      startDate: range.startDate,
      endDate: range.endDate
    })
  }

  return (
    <Fragment>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <TextField
            fullWidth
            type='text'
            label={t('showings.createShowings.form.date')}
            error={invalid && touched && !active}
            helperText={touched && !active && error && error}
            variant='outlined'
            onClick={handleClickOpenCalendar}
            value={
              value.startDate && moment(value.startDate).format('D.M.YYYY')
            }
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            type='text'
            label={t('showings.createShowings.form.date')}
            error={invalid && touched && !active}
            helperText={touched && !active && error && error}
            variant='outlined'
            onClick={handleClickOpenCalendar}
            value={value.endDate && moment(value.endDate).format('D.M.YYYY')}
          />
        </Grid>
      </Grid>

      <Dialog
        dialogId={'CalendarDialog'}
        noOpenDialogButton
        Content={
          <Fragment>
            <DateRange
              minDate={new Date()}
              ranges={[range]}
              onChange={(range) => handleSelection(range)}
            />
          </Fragment>
        }
        confirmDialogSubmitAction={() => handleOnChange()}
      />
    </Fragment>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  openDialog: (id: string) => dispatch(openDialog(id))
})

export default connect(
  null,
  mapDispatchToProps
)(withTranslation()(ReduxDateRangePicker))
